import { createContext, useContext, useState, ReactNode } from 'react';
import FreeTrialWarningModal from './FreeTrialWarningModal';

interface FreeTrialModalContextType {
	isFreeTrialModalOpen: boolean;
	openFreeTrialModal: () => void;
	closeFreeTrialModal: () => void;
}

const FreeTrialModalContext = createContext<
	FreeTrialModalContextType | undefined
>(undefined);

export const FreeTrialModalProvider = ({
	children
}: {
	children: ReactNode;
}) => {
	const [isFreeTrialModalOpen, setIsFreeTrialModalOpen] = useState(false);

	const openFreeTrialModal = () => setIsFreeTrialModalOpen(true);
	const closeFreeTrialModal = () => setIsFreeTrialModalOpen(false);

	return (
		<FreeTrialModalContext.Provider
			value={{
				isFreeTrialModalOpen,
				openFreeTrialModal,
				closeFreeTrialModal
			}}
		>
			{children}
			<FreeTrialWarningModal
				isOpen={isFreeTrialModalOpen}
				onClose={closeFreeTrialModal}
			/>
		</FreeTrialModalContext.Provider>
	);
};

export const useFreeTrialModal = () => {
	const context = useContext(FreeTrialModalContext);
	if (!context) {
		throw new Error(
			'useFreeTrialModal must be used within a FreeTrialModalProvider'
		);
	}
	return context;
};
